export const BRAND_OVERRIDE_COOKIE_KEY = 'feature.override-brand-key';
